

































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getGroupVideos, getGroupList, removeGroup } from '@/api/videoDevice/play'
import { namespace } from 'vuex-class'
import { FailedPermission, PagePermissionState, PermissionData } from '@/store/modules/pagePermission'
import { newGuid } from '@/configs/functions'
const PagePermissionModule = namespace('pagePermission')

@Component({
  components: {
  }
})
/**视频分组 */
export default class GroupList extends Vue {
  @PagePermissionModule.Getter('pagePermission')
  public pagePermission!: PagePermissionState
  public btnCtrl: PermissionData = FailedPermission
  public getPermission() {
    const s = this.pagePermission
    let p = FailedPermission
    if (this.$route.path.indexOf(s.pagePath) > -1) {
      p = s.permission
    }
    this.btnCtrl = p
  }
  @Prop({ default: null })
  public callPlay!: Function

  @Prop({ default: null })
  public hideWnd!: () => void
  @Prop({ default: null })
  public showWnd!: () => void

  public listLoading: boolean = false
  public list: any[] = []
  public queryTerm = {
    Keyword: ''
  }

  public targetId: string = ''
  public created() {
    this.targetId = newGuid()
    this.getPermission()
  }
  public mounted() {
    window.eventBus.$on("submitVideoGroupForm", (info: any) => {
      if (this.targetId = info.targetId) {
        // info.data
        this.fetchData()
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("submitVideoGroupForm")
  }
  //数据加载
  public loadData() {
    //触发控件的查询事件
    this.fetchData()
  }
  public doSearch() {
    this.fetchData()
  }
  public expandKey1: number[] = []
  public fetchData() {
    this.expandKey1 = []
    this.listLoading = true
    getGroupList(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data
        //页面首次加载时，默认打开第一个节点
        if (this.expandKey1.length == 0 && data.length > 0) {
          var row = data[0]
          if (row && row.Id > 0) {
            this.expandKey1 = [row.Id]
            this.fetchVideo(row, null)
          }
        }
      }
      this.listLoading = false
    })
  }
  public fetchVideo(row: any, expandedRows: any) {
    if (!row.childs || row.childs.length == 0) {
      row.childs = []
      row.loading = true
      getGroupVideos(row.Id).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          row.childs = data
          row.loading = false
          var index = this.list.findIndex((v: any) => v.Id == row.Id)
          this.$set(this.list, index, row)
        }
      })
    }
  }
  public doAdd() {
    var data: any = { id: 0, targetId: this.targetId }
    window.eventBus.$emit("openVideoGroupForm", data)
  }
  public doPlay(index: number) {
    var codes: any[] = []
    var group = this.list[index]
    getGroupVideos(group.Id).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        //#region 从后端获取播放列表
        group.childs = data
        group.loading = false

        this.$set(this.list, index, group)
        //#endregion

        //#region 生成播放列表
        var childs = group.childs
        if (childs && childs.length > 0) {
          childs.forEach((e: any, j: number) => {
            codes.push({ code: e.PointNumber, sm: e.StreamMode })
          })
        }
        var count = codes.length
        if (count > 0) {
          if (this.callPlay) {
            var playData: { name: string, codes: any[] } = {
              name: group.GroupName, codes: codes
            }
            this.callPlay(playData)
          }
        }
        else {
          this.$message.warning('请选择需要播放的视频')
        }
        //#endregion
      }
    })
  }
  public doEdit(id: number) {
    var data: any = { id: id, targetId: this.targetId }
    window.eventBus.$emit("openVideoGroupForm", data)
  }
  public doDel(id: number) {
    if (this.hideWnd) {
      this.hideWnd()
    }
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      removeGroup(id).then(() => {
        this.$message({ type: 'success', message: '删除成功!' })
        if (this.showWnd) {
          this.showWnd()
        }
        this.fetchData()
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
      if (this.showWnd) {
        this.showWnd()
      }
    })
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
  }
}
